// Motor de promociones — cálculo local para preview del carrito.
// El backend recalcula de forma autoritativa en el checkout.

/** Vigencia: fechas y, si se definió, días de la semana y horario. */
export function promoVigente(p, ahora = new Date()) {
  const hoy = ahora.toLocaleDateString("en-CA"); // YYYY-MM-DD
  if (p.fecha_inicio && hoy < p.fecha_inicio) return false;
  if (p.fecha_fin && hoy > p.fecha_fin) return false;
  const dias = p.dias_semana || [];
  if (dias.length) {
    const dow = (ahora.getDay() + 6) % 7; // 0 = lunes
    if (!dias.includes(dow)) return false;
  }
  const hi = p.hora_inicio, hf = p.hora_fin;
  if (hi && hf) {
    const hhmm = ahora.toTimeString().slice(0, 5);
    if (hi <= hf) { if (!(hhmm >= hi && hhmm <= hf)) return false; }
    else if (!(hhmm >= hi || hhmm <= hf)) return false;
  }
  return true;
}

export function computePromotions(cart, promotions, channelKey = "canal_ecommerce") {
  const applicable = (promotions || []).filter((p) => p.is_active && p[channelKey] && promoVigente(p));
  if (!applicable.length || !cart.length) return { applied: [], savings: 0 };

  const remaining = {};
  const priceMap = {};
  const catMap = {};
  cart.forEach((it) => {
    remaining[it.product_id] = (remaining[it.product_id] || 0) + it.cantidad;
    priceMap[it.product_id] = it.precio;
    if (it.category_id) catMap[it.product_id] = it.category_id;
  });
  const precio = (pid) => priceMap[pid] || 0;

  const combos = applicable.filter((p) => (p.tipo || "COMBO") === "COMBO");
  const packs = applicable.filter((p) => p.tipo === "PACK_COMBINABLE");
  const descuentos = applicable.filter((p) => p.tipo === "DESCUENTO");

  const applied = [];
  let savings = 0;
  let changed = true;
  while (changed) {
    changed = false;
    for (const promo of combos) {
      const items = promo.items || [];
      if (!items.length) continue;
      if (!items.every((pi) => (remaining[pi.product_id] || 0) >= pi.cantidad)) continue;
      const regular = items.reduce((s, pi) => s + precio(pi.product_id) * pi.cantidad, 0);
      const s = regular - promo.precio_bundle;
      if (s <= 0) continue;
      items.forEach((pi) => { remaining[pi.product_id] -= pi.cantidad; });
      applied.push({ promotion_id: promo.promotion_id, nombre: promo.nombre, tipo: "COMBO", savings: Math.round(s) });
      savings += s;
      changed = true;
    }
    // PACK CANTIDAD COMBINABLE: N unidades del grupo, combinables, a precio fijo
    for (const promo of packs) {
      const n = Number(promo.cantidad_pack || 0);
      const grupo = (promo.items || []).map((pi) => pi.product_id);
      if (n <= 0 || !grupo.length) continue;
      let unidades = [];
      grupo.forEach((pid) => {
        for (let i = 0; i < Math.floor(remaining[pid] || 0); i++) unidades.push(pid);
      });
      if (unidades.length < n) continue;
      unidades.sort((a, b) => precio(b) - precio(a));
      const tomadas = unidades.slice(0, n);
      const regular = tomadas.reduce((s, pid) => s + precio(pid), 0);
      const s = regular - Number(promo.precio_bundle || 0);
      if (s <= 0) continue;
      tomadas.forEach((pid) => { remaining[pid] -= 1; });
      applied.push({ promotion_id: promo.promotion_id, nombre: promo.nombre, tipo: "PACK_COMBINABLE", unidades: n, savings: Math.round(s) });
      savings += s;
      changed = true;
    }
  }
  // DESCUENTO % sobre lo que no entró en un combo o pack
  for (const promo of descuentos) {
    const pct = Number(promo.descuento_pct || 0);
    if (pct <= 0) continue;
    const pids = new Set(promo.product_ids || []);
    const cats = new Set(promo.category_ids || []);
    let s = 0;
    Object.entries(remaining).forEach(([pid, qty]) => {
      if (qty <= 0) return;
      if (pids.has(pid) || (cats.size && cats.has(catMap[pid]))) s += precio(pid) * qty * pct / 100;
    });
    if (s <= 0) continue;
    applied.push({ promotion_id: promo.promotion_id, nombre: promo.nombre, tipo: "DESCUENTO", descuento_pct: pct, savings: Math.round(s) });
    savings += s;
  }
  return { applied, savings: Math.round(savings) };
}
